import { useEffect, useState } from 'react';
// material-ui
import { Box, Chip, IconButton, Link, useMediaQuery } from '@mui/material';
import { GithubOutlined } from '@ant-design/icons';

// project import
import Search from './Search';
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';
import TitleSection from './TitleSection';
import { AUTH_TOKEN_UPDATED_EVENT, getConfiguredInactivity, LAST_ACTIVITY_KEY } from 'hooks/useIdleLogout';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const inactivityTimeout = getConfiguredInactivity();
  const [remainingMs, setRemainingMs] = useState(inactivityTimeout);
  const [hasJwt, setHasJwt] = useState(Boolean(localStorage.getItem('JWT')));

  useEffect(() => {
    const getRemainingMs = () => {
      if (!localStorage.getItem('JWT')) return 0;
      const lastActivity = Number(localStorage.getItem(LAST_ACTIVITY_KEY) || Date.now());
      return Math.max(inactivityTimeout - (Date.now() - lastActivity), 0);
    };

    const syncCountdown = () => {
      setHasJwt(Boolean(localStorage.getItem('JWT')));
      setRemainingMs(getRemainingMs());
    };

    syncCountdown();
    const intervalId = window.setInterval(() => {
      setRemainingMs(getRemainingMs());
    }, 1000);
    const handleStorageChange = (event) => {
      if (event.key === 'JWT' || event.key === LAST_ACTIVITY_KEY) {
        syncCountdown();
      }
    };
    const handleAuthTokenUpdated = () => {
      syncCountdown();
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener(AUTH_TOKEN_UPDATED_EVENT, handleAuthTokenUpdated);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener(AUTH_TOKEN_UPDATED_EVENT, handleAuthTokenUpdated);
    };
  }, [inactivityTimeout]);

  const formatRemaining = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  return (
    <>
      {/* {!matchesXs && <Search />} */}
      {!matchesXs && <TitleSection />}
      {matchesXs && <Box sx={{ width: '100%', ml: 1 }} />}
      {!matchesXs && hasJwt && (
        <Chip
          label={`Idle logout: ${formatRemaining(remainingMs)}`}
          size="small"
          color={remainingMs <= 60 * 1000 ? 'warning' : 'default'}
          sx={{ mr: 1 }}
        />
      )}

      {/* <IconButton
        component={Link}
        href="https://github.com/codedthemes/mantis-free-react-admin-template"
        target="_blank"
        disableRipple
        color="secondary"
        title="Download Free Version"
        sx={{ color: 'text.primary', bgcolor: 'grey.100' }}
      >
        <GithubOutlined />
      </IconButton> */}

      <Notification />
      {!matchesXs && <Profile />}
      {matchesXs && <MobileSection />}
    </>
  );
};

export default HeaderContent;
